/* eslint-disable react-hooks/exhaustive-deps */
import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../../components";
import { MetadataForm } from "../../../components/tracks/all-tracks/MetaDataForm";
import url from "../../../utils/urls";
import TrackUpload, {
  TrackUploadStatus,
} from "../../../components/tracks/all-tracks/TrackUpload";
import {
  createTrack,
  deleteAnalyzeFile,
  getUserInfo,
} from "../../../actions/user";
import useAuth from "../../../hooks/useAuth";
import {
  defaultTrackMetadata,
  defaultSelect,
} from "../../../components/tracks/all-tracks/constants";
import { T_TrackMetadata } from "@type/global.types";
import { message } from "antd";
import { getPostDataFromFormData } from "../../../utils";
import convert from "xml-js";
import dayjs from "dayjs";
import { Backend } from "shared-types";
import { getUploadInfo } from "../../../actions/track";
import { Track } from "../../../actions";

const params = new URLSearchParams(window.location.search);

export const NewTrack: React.FC<any> = (props) => {
  const { dispatchUser } = useAuth() as any;
  const navigate = useNavigate();
  const [uploadId, setUploadId] = useState<number>(
    Number(params.get("file-id")) || 0
  );
  const [isFormDisabled, setFormDisabled] = useState<boolean>(false);
  const [file, setFile] = useState<File | Blob | string | undefined>();
  const [fileName, setFileName] = useState<string>();
  const [formData, setFormData] = useState<T_TrackMetadata>({
    ...defaultTrackMetadata,
    genre: defaultSelect.number,
    subGenre: defaultSelect.number,
    trackType: defaultSelect.string,
    titleLanguage: defaultSelect.number,
    mood: defaultSelect.number,
  });
  const [uploadPercent, setUploadPercent] = useState(0);
  const [audioMetaData, setAudioMetaData] = useState<Backend.T_AudioMetaData>();
  const [isLoading, setLoading] = useState({
    file: false,
    meta: false,
  });
  const [status, setStatus] = useState<TrackUploadStatus>(
    TrackUploadStatus.IDLE
  );

  useEffect(() => {
    if (file) {
      if (file instanceof File) setFileName(file.name);
      if (file instanceof File || file instanceof Blob) {
        setLoading({
          meta: true,
          file: false,
        });
        const hide = message.loading("Uploading file. Just a sec...", 1000);
        setStatus(TrackUploadStatus.PROCESSING_UPLOADS);
        setUploadPercent(0);
        Track.analyzeFile(file, (e) => {
          setUploadPercent((e.loaded / e.total) * 100);
        })
          .then((info) => {
            hide();
            message.success("Success", 3);
            setAudioMetaData(info.metadata);
            setLoading({
              ...isLoading,
              meta: false,
            });
            setFile(url.upload.getFile(info.id));
            setStatus(TrackUploadStatus.ANALYZE_SUCCESS);
            setUploadPercent(0);
            setUploadId(info.id);
            navigate(url.track.newFrontend(info.id));
          })
          .catch(() => {
            message.success("Error to upload file", 3);
            setLoading({
              ...isLoading,
              meta: false,
            });
            setStatus(TrackUploadStatus.ANALYZE_ERROR);
          });
      }
    }
  }, [file]);

  useEffect(() => {
    const main = async () => {
      const params = new URLSearchParams(window.location.search);
      const fid = Number(params.get("file-id"));
      setUploadId(fid);
      setStatus(TrackUploadStatus.IDLE);
      if (fid) {
        try {
          setLoading({
            file: true,
            meta: true,
          });
          const info = await getUploadInfo(fid);
          setFile(url.upload.getFile(fid));
          setStatus(TrackUploadStatus.FILE_SELECTED);
          setLoading({
            file: false,
            meta: true,
          });
          if (info.analyzedata) {
            try {
              const meta = JSON.parse(info.analyzedata);
              setAudioMetaData(meta);
            } catch (error) { }
          }
          setStatus(TrackUploadStatus.ANALYZE_SUCCESS);
          setLoading({
            file: false,
            meta: false,
          });
          setFileName(info.uploadname || "no-name.mp3");
        } catch (error) {
          setStatus(TrackUploadStatus.IDLE);
          navigate(url.track.newFrontend());
          setLoading({
            file: false,
            meta: false,
          });
        }
      }
    };
    main();
  }, []);

  const onFormSubmit = async (metaData: T_TrackMetadata) => {
    console.log("file", file)
    try {
      if (file) {
        if (file instanceof File || file instanceof Blob) {
          metaData.trackFile = file;
          metaData.trackFileName = fileName || `new-file.mp3`;
          metaData.tempTrackInfo.id = uploadId;
        } else if (typeof file === "string") {
          metaData.trackFileName = fileName || `new-file.mp3`;
          metaData.tempTrackInfo.id = uploadId;
        }
        const formData = getPostDataFromFormData(metaData);
        setFormDisabled(true);
        const result = await createTrack(formData);
        if (result.status) message.success("Success");
        else message.warning(result.message);
        setFormDisabled(false);
        getUserInfo()
          .then((response) => {
            dispatchUser(response.data.userInfo);
          })
          .catch(console.warn);
        navigate("/all-tracks?mysong=true");
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        message.warning("Please upload your song.");
        return;
      }
    } catch (error) {
      message.warning("error to create new track");
      console.log(error);
      setFormDisabled(false);
    }
  };

  const getFormDataFromText = (text: string): any => {
    const jsonStr = convert.xml2json(text);
    let obj = JSON.parse(jsonStr);
    let res: any = xmlObjectToJson(obj.elements);
    let data = res["track-info"];
    if (data) {
      if (data.distributionTerr) {
        if (data.distributionTerr instanceof Array) {
          let n = data.distributionTerr.length;
          for (let i = 0; i < n; i++) {
            data.distributionTerr[i].value = Number(
              data.distributionTerr[i].value
            );
          }
        } else {
          data.distributionTerr = [data.distributionTerr];
        }
      }
      if (data.performers) {
        if (!(data.performers instanceof Array)) {
          data.performers = [data.performers];
        }
        let n = data.performers.length;
        for (let i = 0; i < n; i++) {
          data.performers[i].primary = data.performers[i].primary === "true";
          data.performers[i].role = Number(data.performers[i].role);
          data.performers[i].id = Number(data.performers[i].id);
        }
      }
      console.log(data, "data")
      data.releaseDate = dayjs(res.releaseDate);
      data.instPossibleVal = Number(res.instPossibleVal) || 0;
      data.explicitContent = Number(res.explicitContent) || 0;
      data.yearOfPublication = dayjs(res.yearOfPublication);
      data.genre.value = Number(data.genre.value);
      data.trackFile = file;
      data.trackFileName = fileName || "no-name.mp3";
      return data;
    } else {
      message.warning("Invalid file");
    }
  };

  const exportTrackInfoFile = (data: T_TrackMetadata) => {
    const element = document.createElement("a");
    const json = { "track-info": { ...data, trackFile: null } };
    const jsonStr = JSON.stringify(json);
    const xml = convert.json2xml(jsonStr, { spaces: 0, compact: true });
    element.setAttribute(
      "href",
      `data:text/plain;charset=utf-8,${encodeURIComponent(xml)}`
    );
    element.setAttribute("download", "test.xml");
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const getFileText = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = function (event: ProgressEvent<FileReader>) {
        var fileContent = event?.target?.result?.toString() || "";
        resolve(fileContent);
      };
      reader.readAsText(file);
    });

  async function onChangeXMLFile(event: ChangeEvent<HTMLInputElement>) {
    if (event.target.files?.length) {
      const file = event.target.files[0];
      const text = await getFileText(file);
      const data = getFormDataFromText(text);
      setFormData(data);
      event.target.value = "";
    }
  }

  const xmlObjectToJson = (obj: any[]) => {
    if (!obj) return null;
    if (obj.length === 1 && obj[0].type === "text") return obj[0].text;
    let res: { [key: string]: any } = {};
    let len = obj.length;
    for (let i = 0; i < len; i++) {
      const ret = xmlObjectToJson(obj[i].elements);
      if (ret != null) {
        if (res[obj[i].name] != null) {
          if (!!!(res[obj[i].name] instanceof Array))
            res[obj[i].name] = [res[obj[i].name]];
          res[obj[i].name].push(ret);
        } else res[obj[i].name] = ret;
      }
    }
    return res;
  };

  function onClickImport() {
    const inputElement: HTMLInputElement | undefined = document.querySelector(
      "input[type=file].xml-select"
    ) as HTMLInputElement | undefined;
    inputElement?.click();
  }

  const onChangeFormData = (data: T_TrackMetadata) => {
    setFormData({ ...data });
  };

  const deleteFile = async () => {
    if (file && uploadId) {
      const hide = message.loading("Deleting uploaded file...", 1000);
      setFile(undefined);
      const su = await deleteAnalyzeFile(uploadId);
      hide();
      if (su) {
        setStatus(TrackUploadStatus.IDLE);
        message.success("Success", 3);
        navigate(url.track.newFrontend());
      } else message.warning("Error to delete uploaded file", 3);
    }
  };

  return (
    <div className="page-new-track">
      <PageHeader title={"New Track"} />
      <div className="tw-bg-blue tw-py-4">
        <TrackUpload
          className="tw-py-5 uk-container-large"
          file={file}
          setFile={setFile}
          isLoading={isLoading}
          status={status}
          setStatus={setStatus}
          uploadPercent={uploadPercent}
          audioMetaData={audioMetaData}
          deleteFile={deleteFile}
        />
      </div>
      <div className="uk-container-large">
        <div>
          <input
            type="file"
            className="xml-select tw-hidden"
            onChange={onChangeXMLFile}
          />
        </div>
        <MetadataForm
          formData={{
            type: "meta-data",
            data: formData,
          }}
          onSubmit={onFormSubmit}
          disabled={isFormDisabled}
          onClickImport={onClickImport}
          onClickExport={exportTrackInfoFile}
          setFormData={onChangeFormData}
        />
      </div>
    </div>
  );
};

export default NewTrack;
